import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

interface AuthErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const AuthErrorDialog = ({ isOpen, onClose }: AuthErrorDialogProps) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleRelogin = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Authentication Error</AlertDialogTitle>
          <AlertDialogDescription>
            Your session has expired or there's an authentication issue. Please log in again to continue.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleRelogin}>
            Log in again
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AuthErrorDialog;